<template>
  <div>
    <h3 class="font-weight-bold">Telefones</h3>

    <table class="table mt-2">
      <tbody v-for="phone in phones" v-bind:key="phone.id">
        <tr v-if="phone.defaultPhoneNumber">
          <button class="btn btn-outline-primary mb-3"
            :value="phone.phoneNumber"
            v-b-modal.bv-modal-sms
            @click="setSms(phone.phoneNumber)"
          >
            <span><i class="fa fa-paper-plane"></i></span>
            <span>Mensagem de SMS</span>
          </button>
        </tr>
        <tr :class="phone.defaultPhoneNumber ? 'font-weight-bold' : ''">
          <td>{{ phone.source + ': ' + phone.phoneNumber }}</td>
          <td>{{ phone.confirmed ? 'Confirmado' : '' }}</td>
          <td>{{ phone.defaultPhoneNumber ? 'Padrão' : '' }}</td>
          <td class="text-right">
            <div class="dropdown">
              <button class="btn btn-bare dropdown-toggle pl-2 pr-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="m-0 fa fa-ellipsis-v"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" href="#" @click="makeDefaultPhone(phone.id)">Tornar Padrão</a>
                <a class="dropdown-item" :href="'https://api.whatsapp.com/send?phone=55' + phone.phoneNumber" target="_blank">Enviar WhatsApp</a>
                <a class="dropdown-item" href="#" @click="showScreen()">Novo</a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <form class="form-inline mb-5">
      <div class="form-group mx-sm-3">
        <label for="new-phone" class="sr-only">Novo telefone</label>
        <input-component class="form-control" placeholder="Novo Telefone" mask="(##) #####-####" type='text' @updateValue="val => newPhone = val" :model="newPhone"/>
      </div>
      <b-button variant="primary" @click="addPhone">Adicionar</b-button>
    </form>

    <b-modal id="bv-modal-sms" ref="my-modal" hide-footer title="Opções de mensagens">
      <b-button class="btn btn-outline-primary" v-b-modal.bv-modal-whatsapp-require variant="outline-primary" block>Envio de SMS para solicitação de whatsapp ativo<b-spinner v-if="loadingConfirmWhatsMessage" small class="buttonSpinner"></b-spinner></b-button>
      <b-button class="btn btn-outline-primary" v-b-modal.bv-modal-order-expired variant="outline-primary" block>Envio de SMS para pedido expirado<b-spinner v-if="loadingOrderExpiredMessage" small class="buttonSpinner"></b-spinner></b-button>
    </b-modal>
    <b-modal id="bv-modal-whatsapp-require" size="lg" @ok="sendSmsConfirmWhats">
      <div class="d-block">
        <b-form-group
          id="input-group-1"
          label="A seguinte mensagem será enviada:"
          label-for="input-1"
        >
        <p>{{ this.confirmWhatsMessage }}</p>
        </b-form-group>
      </div>
    </b-modal>
    <b-modal id="bv-modal-order-expired" size="lg" @ok="sendSmsOrderExpiredMessage">
      <div class="d-block">
        <b-form-group
          id="input-group-1"
          label="A seguinte mensagem será enviada:"
          label-for="input-1"
        >
        <p>{{ this.orderExpiredMessage }}</p>
        </b-form-group>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Button from '../../button/Button.vue'
import Input from '../../form/Input.vue'

export default {
  components: {
    'button-component': Button,
    'input-component': Input
  },
  data () {
    return {
      phones: null,
      newPhone: null,
      userPhone: '',
      openScreen: false,
      loadingConfirmWhatsMessage: false,
      loadingOrderExpiredMessage: false,
      confirmWhatsMessage: `Olá, para avaliarmos seu Boleto Parcelado do pedido ${this.reference}, por favor entre em contato por WhatsApp no número 48 99668-3593. Atte. BoletoFlex`,
      orderExpiredMessage: `Olá, seu pedido ${this.reference} expirou, por favor refaça sua compra e pague com o Boleto Parcelado utilizando um número com WhatsApp ativo. Atte. BoletoFlex`
    }
  },
  props: ['user', 'tx', 'reference'],
  methods: {
    setSms (phone) {
      this.userPhone = phone
    },
    showScreen () {
      var body = document.body

      if (!this.openScreen) {
        body.classList.add('aside-menu-lg-show')
        this.openScreen = true
      } else {
        body.classList.remove('aside-menu-lg-show')
        this.openScreen = false
      }
    },
    sendSmsConfirmWhats () {
      this.loadingConfirmWhatsMessage = true
      this.$http.post(`api/validations/${this.$route.params.txid}/sendSms`, {
        to: this.userPhone,
        message: this.confirmWhatsMessage
      })
        .then(function (res) {
          this.loadingConfirmWhatsMessage = false
          console.log(res)
          this.$bvToast.toast(`SMS enviado com sucesso !`, {
            title: 'SMS de solicitação de Whatsapp',
            autoHideDelay: 5000,
            variant: 'primary'
          })
        })
        .catch(function (res) {
          this.loadingConfirmWhatsMessage = false
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(`Problema ao enviar sms ${res.data}`, {
            title: 'Erro ao enviar',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    sendSmsOrderExpiredMessage () {
      this.loadingOrderExpiredMessage = true
      this.$http.post(`api/validations/${this.$route.params.txid}/sendSms`, {
        to: this.userPhone,
        message: this.orderExpiredMessage
      })
        .then(function (res) {
          this.loadingOrderExpiredMessage = false
          console.log(res)
          this.$bvToast.toast(`SMS enviado com sucesso !`, {
            title: 'SMS de solicitação de Whatsapp',
            autoHideDelay: 5000,
            variant: 'primary'
          })
        })
        .catch(function (res) {
          this.loadingOrderExpiredMessage = false
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(`Problema ao enviar sms ${res.data}`, {
            title: 'Erro ao enviar',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    loadPhones () {
      this.$root.$emit('loadphone')
      this.$http.get('api/validations/' + this.$route.params.txid + '/phones')
        .then(function (res) {
          this.phones = res.data.list
          this.phones = this.phones.sort(function (a, b) {
            return (a.defaultPhoneNumber === b.defaultPhoneNumber) ? 0 : a.defaultPhoneNumber ? -1 : 1
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    addPhone () {
      this.$http.post('api/validations/' + this.$route.params.txid + '/phones', {phoneNumber: this.newPhone})
        .then(function (res) {
          this.loadPhones()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(`${this.newPhone} ${res.data}`, {
            title: 'Erro ao adicionar',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    makeDefaultPhone (id) {
      this.$http.post('api/validations/' + this.$route.params.txid + '/phones/' + id)
        .then(function (res) {
          this.loadPhones()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(`${res.data}`, {
            title: 'Erro ao marcar como padrão',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    extractFirstName (name) {
      let index = name.trim().indexOf(' ')
      return index > 0 ? name.substring(0, index) : name
    }
  },
  mounted () {
    this.loadPhones()
  },
  watch: {
    '$route.params.txid' () {
      this.loadPhones()
    }
  }
}
</script>
<style lang="scss">
.smsButton {
  width: 100%;
  margin-bottom: 15px;
}

.buttonSpinner {
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/partial/cards/contacts/ContactPhoneManager.vue